import React from "react";
import FormContentWrapper from "Components/FormContentWrapper";
import { useFormData } from "Contexts/FormDataContext";
import { useSession } from "Contexts/SessionContext";
import usePageContextUpdate from "Hooks/usePageContextUpdate";
import MarketingChannelFormContent from "Components/MarketingChannel/MarketingChannelFormContent";
import MarketingChannelInfoContent from "Components/MarketingChannel/MarketingChannelInfoContent";
import { marketingChannelData, getPageNumber } from "Data";

const MarketingChannelPage = () => {
  const { currentPageData, setSubmitted } = usePageContextUpdate();

  const {
    updateMarketingChannels,
    currentFormData: {
      primaryMarketingChannels,
      primaryMarketingChannelsOther,
    },
  } = useFormData();

  const { updateSession, sessionData } = useSession();

  const calculateScore = (selectedChannels) => {
    return selectedChannels.reduce((total, channelValue) => {
      const channel = marketingChannelData.find(
        (c) => c.value === channelValue,
      );
      return total + (channel?.score || 0);
    }, 0);
  };

  const handleSubmit = async (data) => {
    const { channels, otherChannel } = data;
    const score = calculateScore(channels);

    updateMarketingChannels(channels, otherChannel, score);

    await updateSession({
      current_page: getPageNumber("nurturing-approach"),
      q4_score: score,
      responses: {
        ...sessionData?.responses,
        q4_marketing_channels: {
          channels,
          other: otherChannel || "",
          score,
        },
      },
    });

    setSubmitted(true);
  };

  return (
    <FormContentWrapper
      infoContent={
        <MarketingChannelInfoContent heading={currentPageData.pageTitle} />
      }
      formFieldContent={
        <MarketingChannelFormContent
          submitCB={handleSubmit}
          defaultChannels={primaryMarketingChannels}
          defaultOther={primaryMarketingChannelsOther}
        />
      }
    />
  );
};

export default MarketingChannelPage;
